// extracted by mini-css-extract-plugin
module.exports = {"body":"notification-button_body__tms6c"};